module.exports = __webpack_public_path__ + "static/media/book-online-banner.d4da3946.jpg";